import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {Match} from '../../../../model/events/Match';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ErrorType} from '../../../../model/error-type';
import {RestErrorHelper} from '../../../../helper/rest-error-helper';
import {PerformanceService} from '../../../../services/performance.service';
import {ConfirmationService, MessageService} from 'primeng/api';
import {FrontendService} from '../../../../services/frontend.service';
import {environment} from '../../../../../environments/environment';
import {StatisticsService} from '../../../../services/statistics.service';
import {Right} from '../../../../model/Right';
import {FUNCTION_STATISTIC_MANUAL_AVERAGES} from '../../../../rightsCatalog';
import {RightsService} from '../../../../services/rights.service';
import {Participant} from '../../../../model/participants/Participant';
import {DOMAIN_CD_TOURNAMENTKIND_DOUBLE} from '../../../../constants';
import {InputBoxComponent, InputBoxResult} from '../../common/input-box/input-box.component';
import {TeamleagueService} from '../../../backend/event/event-module/event-ergebnisse/service/teamleague.service';
import {SessionService} from '../../../../services/session.service';
import {ViewHelper} from '../../helper/view-helper';
import {Player} from '../../../../model/participants/Player';
import {MessageComponent} from '../../../../components/generic/message/message.component';
import {LoadingComponent} from '../../../../components/generic/loading/loading.component';
import {SkeletonModule} from 'primeng/skeleton';
import {NgForOf, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PlayerPipe} from '../../../../pipes/player.pipe';
import {InputNumberModule} from 'primeng/inputnumber';
import {Button} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {PerformancePlayerPipe} from '../../../../pipes/performancePlayerPipe';
import {DomainValuePipe} from '../../../../pipes/domain-value.pipe';
import {TooltipModule} from 'primeng/tooltip';
import {InputText} from 'primeng/inputtext';
import {Select} from 'primeng/select';

@Component({
  standalone: true,
  selector: 'app-spiel-performances',
  templateUrl: './spiel-performances.component.html',
  styleUrls: ['./spiel-performances.component.scss'],
  imports: [
    MessageComponent,
    LoadingComponent,
    SkeletonModule,
    NgIf,
    NgForOf,
    TranslateModule,
    FormsModule,
    PlayerPipe,
    InputNumberModule,
    TableModule,
    PerformancePlayerPipe,
    DomainValuePipe,
    TooltipModule,
    Button,
    InputText,
    Select
  ],
  encapsulation: ViewEncapsulation.None
})
export class SpielPerformancesComponent implements OnInit
{
  @Input() set configurationData(value: any)
  {
    this.initConfiguration(value);
  }

  isLoading: boolean;
  isLoadingRequirements: boolean;
  isSaving: boolean;
  errorMsg: ErrorType;
  isMobile: boolean;

  frontend: boolean;
  databaseId: number;
  rightAverages: Right;
  readOnly = true;
  eventId: number;
  participant: Participant;
  match: Match;
  data: any[];
  showAverage: boolean;
  participants: Participant[];
  selectedParticipant: Participant;
  selectedMemberPlayer: Player;
  selectedMemberPlayerDouble1: Player;
  selectedMemberPlayerDouble2: Player;

  domainPerformanceTypes: any[];
  domainPerformanceTypesOdd: any[];
  players: any[];
  useMemberPlayers: boolean;
  memberPlayers: Player[];
  inputValues: any[][];
  inputAverages: any[];
  averagesDisabled: boolean;

  constructor(private dialogService: DialogService,
              private performanceService: PerformanceService,
              private statisticsService: StatisticsService,
              private frontendService: FrontendService,
              private translate: TranslateService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService,
              private rightsService: RightsService,
              public teamleagueService: TeamleagueService,
              private sessionService: SessionService,
              private restErrorHelper: RestErrorHelper)
  {
    this.rightAverages = this.rightsService.getRightFromKey(FUNCTION_STATISTIC_MANUAL_AVERAGES);
    this.isMobile = ViewHelper.isMobile();
  }

  private initConfiguration(configurationData: any): void
  {
    console.log('initConfiguration: ', configurationData);
    if (configurationData)
    {
      this.readOnly = configurationData.readOnly;
      this.frontend = !!configurationData.frontend;
      this.eventId = configurationData.eventId;
      this.participant = configurationData.participant;
      this.match = configurationData.match;
      this.databaseId = configurationData.databaseId;
      if (this.match?.eventId)
        this.eventId = this.match.eventId;

      this.averagesDisabled = !this.match || this.match.statusCd !== 'FINISH';
      this.showAverage = this.rightAverages.c;
    }
    else
    {
      this.readOnly = true;
      this.showAverage = false;
    }
    if (this.teamleagueService.isEditingNotAllowed || TeamleagueService.isEditingDenied(this.match?.approveStatusCd,
      this.sessionService))
      this.readOnly = true;

    console.log('Match', this.match);
    console.log('Participant', this.participant);
    console.log('readOnly: ' + this.readOnly + ', isEditingNotAllowed: ' + this.teamleagueService.isEditingNotAllowed +
      ', databaseId: ' + this.databaseId + ', frontend: ' + this.frontend);

    if (!this.readOnly)
      this.loadPerformanceRequirements();
    this.loadData(true);
  }

  ngOnInit(): void
  {
  }

  private loadData(showLoading: boolean): void
  {
    if (showLoading)
      this.isLoading = true;

    const editingDenied = TeamleagueService.isEditingDenied(this.match?.approveStatusCd, this.sessionService);
    console.log('editingDenied: ' + editingDenied);
    console.log('isEditingNotAllowed: ' + this.teamleagueService.isEditingNotAllowed);
    console.log('readOnly: ' + this.readOnly);
    console.log('frontend: ' + this.frontend);

    if (this.frontend || (this.readOnly && this.match && !(this.teamleagueService.isEditingNotAllowed || editingDenied)))
    {
      this.frontendService.getPerformancesForMatch(this.databaseId, this.eventId, this.match.id,
        this.match.matchReport).subscribe({
        next: data =>
        {
          console.log('Bestleistungen erhalten', data);
          this.data = data;
          this.prepareData();
          this.isLoading = false;
        },
        error: error =>
        {
          console.log('error', error);
          this.isLoading = false;
          this.errorMsg = this.restErrorHelper.getErrorType(error);
        }
      });
    }
    else
    {
      this.performanceService.getPerformancesForMatch(this.eventId, this.match, this.participant?.id).subscribe({
        next: data =>
        {
          console.log('[SpielPerformances.ts] Bestleistungen erhalten', data);
          this.data = data;
          this.prepareData();
          this.isLoading = false;
        },
        error: error =>
        {
          console.log('error', error);
          this.isLoading = false;
          this.errorMsg = this.restErrorHelper.getErrorType(error);
        }
      });
    }
  }

  private prepareData(): void
  {
    console.log('prepareData(), match: ', this.match);
    if (!this.data || !this.match?.matchReport)
      return;

    console.log('prepareData()');
    this.data.sort((x, y) =>
    {
      const team1 = x.team;
      const team2 = y.team;
      if (team1 && !team2)
        return 1;
      else if (!team1 && team2)
        return -1;
      else
      {
        const teamCompare = (team1 && team2) ? team1.name.localeCompare(team2.name) : 0;
        if (teamCompare !== 0)
          return teamCompare;
        else
        {
          const name1 = x.participant?.displayName;
          const name2 = y.participant?.displayName;
          console.log('Name1: ' + name1 + ', Name2: ' + name2);
          const nameCompare = (name1 && name2) ? name1.localeCompare(name2) : 0;
          if (nameCompare !== 0)
            return nameCompare;
          else
          {
            const perfCompare = x.performanceTypeCd.localeCompare(y.performanceTypeCd);
            if (perfCompare !== 0)
              return perfCompare;
            else
            {
              if (x.value > y.value)
                return -1;
              else if (y.value > x.value)
                return -1;
              else
              {
                if (x.count > y.count)
                  return -1;
                else if (x.count < y.count)
                  return 1;
                else return 0;
              }
            }
          }
        }
      }
    });

    // Mannschafts-Header einbauen
    let lastTeamId = 0;
    let index = 0;
    for (const performance of this.data)
    {
      if (performance.team)
      {
        if (lastTeamId !== performance.team.id)
        {
          // Header einbauen
          this.data.splice(index, 0, {
            header: true,
            name: performance.team.name
          });
          lastTeamId = performance.team.id;
        }
      }
      index++;
    }
  }

  private loadPerformanceRequirements(): void
  {
    this.isLoadingRequirements = true;

    this.performanceService.getPerformanceRequirementsForEvent(this.eventId, this.match?.id,
      this.participant?.id).subscribe({
      next: data =>
      {
        console.log('[SpielPerformances.ts] Bestleistungsvoraussetzungen erhalten', data);
        this.domainPerformanceTypes = data.performances;
        this.domainPerformanceTypesOdd = [];
        for (const performanceType of this.domainPerformanceTypes)
        {
          if (!performanceType.tournamentKindCd || performanceType.tournamentKindCd === 'SINGLE')
          {
            this.domainPerformanceTypesOdd.push(performanceType);
          }
        }
        this.players = data.players;
        this.memberPlayers = data.memberPlayers;
        if (this.memberPlayers)
          this.useMemberPlayers = true;
        this.initMatchReport(data);

        console.log('domainPerformanceTypes', this.domainPerformanceTypes);
        console.log('domainPerformanceTypesOdd', this.domainPerformanceTypesOdd);

        this.inputAverages = [];
        this.inputValues = [];
        for (const item1 of this.players)
        {
          const pf = [];
          for (const item of this.domainPerformanceTypes)
            pf.push(undefined);
          this.inputValues.push(pf);

          this.inputAverages.push(undefined); // TODO Averages laden
        }

        this.isLoadingRequirements = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.isLoadingRequirements = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  private initMatchReport(data: any): void
  {
    this.participants = data.participants;
    if (this.participants)
    {
      for (const participant of this.participants)
      {
        if (participant.players)
          participant.numberOfPlayers = participant.players.length;
        else participant.numberOfPlayers = 0;
      }

      this.participants.sort((x, y) => this.compareTeamName(x, y) ||
        (+x.numberOfPlayers) - (+y.numberOfPlayers) || x.displayName.localeCompare(y.displayName));
    }

    if (this.match?.matchReport)
    {
      // Dummy-Spieler anlegen für alle Teilnehmer (Combobox)
      this.players = [];
      // if (EventHelper.isFinalResult(this.match.phase))
      if (this.useMemberPlayers)
      {
        this.players.push({
          id: 0,
          refresh: false,
          showSingle: true,
          showDouble: false
        });
        this.players.push({
          id: 0,
          refresh: false,
          showSingle: false,
          showDouble: true
        });
      }
      else
      {
        this.players.push({
          id: 0,
          refresh: false
        });
      }

      // Einstellungen für Liga
      this.showAverage = false;
    }
  }

  private compareTeamName(p1: Participant, p2: Participant): number
  {
    const team1 = p1.team?.name || '';
    const team2 = p2.team?.name || '';
    return team1.localeCompare(team2);
  }

  public showPerformanceInput(performanceType: any, index: number): boolean
  {
    if (this.match?.matchReport)
    {
      if (this.useMemberPlayers)
      {
        if ((index === 0 && performanceType.tournamentKindCd === DOMAIN_CD_TOURNAMENTKIND_DOUBLE) ||
          (index === 1 && performanceType.tournamentKindCd !== DOMAIN_CD_TOURNAMENTKIND_DOUBLE))
          return false;

        if (index === 0 && !this.selectedMemberPlayer)
          return false;
        else if (index === 1 && (!this.selectedMemberPlayerDouble1 || !this.selectedMemberPlayerDouble2 ||
          this.selectedMemberPlayerDouble1.id === this.selectedMemberPlayerDouble2.id ||
          this.selectedMemberPlayerDouble1.team?.id !== this.selectedMemberPlayerDouble2.team?.id))
        {
          return false;
        }
        else return true;
      }
      else
      {
        if (!this.selectedParticipant)
          return false;
        if (performanceType.tournamentKindCd === DOMAIN_CD_TOURNAMENTKIND_DOUBLE)
          return this.selectedParticipant.numberOfPlayers > 1;
        else return this.selectedParticipant.numberOfPlayers <= 1;
      }
    }
    else return true;
  }

  public onEdit(performance: any): void
  {
    console.log('onEdit', performance);

    const ref = InputBoxComponent.showDialog(this.dialogService, this.translate.instant('BEST_PERFORMANCE'),
      this.translate.instant('VALUE'), performance.count, 'SAVE');

    ref.onClose.subscribe((result: InputBoxResult) => {
      console.log('result: ', result);
      if (result && result.success)
      {
        const performanceCount = +result.value;
        if (performanceCount > 0)
        {
          const countBefore = performance.count;
          performance.eventId = this.eventId;
          performance.count = performanceCount;

          this.performanceService.updatePerformancePlayerCount(performance).subscribe({
            next: data =>
            {
              console.log('Bestleistung aktualisiert', data);
              // this.loadData(false);
            },
            error: error =>
            {
              performance.count = countBefore;
              this.restErrorHelper.handleErrorService(error);
            }
          });
        }
      }
    });
  }

  public onDelete(performance: any): void
  {
    this.confirmationService.confirm({
      message: this.translate.instant('MSG_DELETE_ITEM', {value: performance.value}),
      header: this.translate.instant('MSG_HEADER_DELETE_ENTRY'),
      icon: 'pi pi-question-circle',
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      rejectButtonStyleClass: 'button-no button-right',
      acceptButtonStyleClass: '',
      accept: () =>
      {
        this.performanceService.deletePerformancePlayer(performance.id).subscribe({
          next: data =>
          {
            console.log('Bestleistung gelöscht', data);
            this.loadData(false);
          },
          error: error => this.restErrorHelper.handleErrorService(error)
        });
      }
    });
  }

  savePerformances(): void
  {
    console.log('savePerformances', this.inputValues);
    if (this.match?.matchReport && (!(this.selectedParticipant || this.selectedMemberPlayer) && !(this.selectedMemberPlayerDouble1 && this.selectedMemberPlayerDouble2)))
      return;

    const performances = [];

    let playerIndex = 0;
    for (const player of this.inputValues)
    {
      let valueIndex = 0;
      for (const valueString of player)
      {
        if (valueString)
        {
          const playerTemp = this.players[playerIndex];
          const performanceType = this.domainPerformanceTypes[valueIndex];

          const valueSplit = valueString.split(',');
          for (let value of valueSplit)
          {
            value = value.trim();
            console.log('Value: ' + value + ', Type: ' + performanceType.name + ', Player: ' + playerTemp.displayName,
              performanceType);
            if (value >= performanceType.min && value <= performanceType.max)
            {
              if (this.match?.matchReport)
              {
                if (this.useMemberPlayers && playerIndex === 1)
                {
                  // Doppel (ohne Participant)
                  if (this.selectedMemberPlayerDouble1 && this.selectedMemberPlayerDouble2)
                  {
                    performances.push({
                      count: 1,
                      value,
                      performanceTypeCd: performanceType.performanceTypeCd,
                      performance: performanceType,
                      player: this.selectedMemberPlayerDouble1,
                      player2: this.selectedMemberPlayerDouble2,
                      team: this.selectedMemberPlayerDouble1?.team,
                      match: this.match ? {id: this.match.id} : undefined
                    });
                  }
                }
                else if (playerIndex === 0)
                {
                  if (this.selectedParticipant || this.selectedMemberPlayer)
                  {
                    performances.push({
                      count: 1,
                      value,
                      performanceTypeCd: performanceType.performanceTypeCd,
                      performance: performanceType,
                      player: this.selectedMemberPlayer ?? undefined,
                      participant: this.selectedParticipant ?? undefined,
                      team: this.selectedMemberPlayer?.team ? this.selectedMemberPlayer.team : this.selectedParticipant?.team,
                      match: this.match ? {id: this.match.id} : undefined
                    });
                  }
                }
              }
              else
              {
                performances.push({
                  count: 1,
                  value,
                  performanceTypeCd: performanceType.performanceTypeCd,
                  performance: performanceType,
                  player: playerTemp,
                  participant: undefined,
                  match: this.match ? {id: this.match.id} : undefined
                });
              }
            }
            else
            {
              this.messageService.add({
                severity: 'warn',
                summary: this.translate.instant('PERFORMANCE_VALUE_NOT_IN_RANGE', {value: performanceType.min + '-' + performanceType.max}),
                life: environment.toastDurationShort
              });
              return;
            }
          }
        }

        valueIndex++;
      }

      playerIndex++;
    }

    console.log('Speichere Bestleistungen:', performances);
    if (performances?.length > 0)
    {
      this.performanceService.savePerformancePlayer(performances, this.eventId).subscribe({
        next: data =>
        {
          console.log('Bestleistungen gespeichert', data);
          this.saveAverages();

          this.isSaving = false;
          this.loadData(false);

          let playerIndexTemp = 0;
          for (const players of this.inputValues)
          {
            let valueIndex = 0;
            for (const value of players)
            {
              this.inputValues[playerIndexTemp][valueIndex] = undefined;
              valueIndex++;
            }

            const player = this.players[playerIndexTemp];
            if (player)
            {
              player.refresh = true;
              setTimeout(() => player.refresh = false, 0);
            }

            playerIndexTemp++;
          }
        },
        error: error =>
        {
          this.isSaving = false;
          this.restErrorHelper.handleErrorService(error);
          this.saveAverages();
        }
      });
    }
    else
    {
      this.saveAverages();
    }
  }

  private saveAverages(): void
  {
    if (!this.showAverage)
      return;
    console.log('saveAverages');
    const averages = [];

    let playerIndex = 0;
    for (const playerAverage of this.inputAverages)
    {
      const player = this.players[playerIndex];
      if (playerAverage > 0)
      {
        averages.push({
          player,
          matchId: this.match?.id,
          average: playerAverage
        });
      }
      playerIndex++;
    }

    console.log('Speichere Averages:', averages);
    if (averages && averages.length > 0)
    {
      this.statisticsService.savePlayerAverages(this.eventId, averages).subscribe({
        next: data =>
        {
          console.log('Averages gespeichert', data);
          let index = 0;
          for (const playerAverage of this.inputAverages)
          {
            this.inputAverages[index++] = undefined;
          }
        },
        error: error => this.restErrorHelper.handleErrorService(error)
      });
    }
  }
}
